import { addUseProcess, getUseProcessList } from '@/api/system/home'
import { useEventUtil } from '@/utils/event'
import { isShowProofingProcess, setShowProofingProcess } from '@/api/price/proofing'

export default {
  namespaced: true,
  state: {
    isRemind: false, //是否提醒
    isCompleted: true, //是否完成
    processList: [
      {
        id: 1,
        title: '账号开通流程',
        list: [
          {
            id: 1,
            title: '注册企业账号',
            path: '/login',
            icon: 'user-plus',
            color: '#00B8A9',
            isCompleted: true
          },
          {
            id: 2,
            title: '登录账号',
            path: '/login',
            icon: 'sign-in',
            color: '#00A8E8',
            isCompleted: true
          },
          {
            id: 3,
            title: '设置系统权限',
            path: '/manage/permission',
            icon: 'shield',
            color: '#8165FC',
            isCompleted: false
          },
          {
            id: 4,
            title: '设置部门、员工账号',
            path: '/manage/staff',
            icon: 'user',
            color: '#FE6752',
            isCompleted: false
          }
        ]
      },
      {
        id: 2,
        title: '验货操作流程',
        list: [
          {
            id: 1,
            title: '维护疵点类型',
            path: '/quality/basic/defectType',
            icon: 'bug',
            color: '#FFB400',
            isCompleted: false
          },
          {
            id: 2,
            title: '维护验货类型',
            path: '/quality/basic/inspectionType',
            icon: 'tags',
            color: '#43AA8B',
            isCompleted: false
          },
          {
            id: 3,
            title: '设置基本清单',
            path: '/quality/inspection/basic',
            icon: 'list',
            color: '#4580F3',
            isCompleted: false
          },
          {
            id: 4,
            title: '设置质检清单',
            path: '/quality/inspection/item',
            icon: 'file-text',
            color: '#31B965',
            isCompleted: false
          },
          {
            id: 5,
            title: '设置流程配置',
            path: '/quality/inspection/process',
            icon: 'cogs',
            color: '#FE9A30',
            isCompleted: false
          },
          {
            id: 6,
            title: '创建质检任务',
            path: 'mini',
            icon: 'tasks',
            color: '#F56C6C',
            isCompleted: true
          },
          {
            id: 7,
            title: '下载质检报告',
            path: '/quality/order/list',
            icon: 'download',
            color: '#A259FF',
            isCompleted: false
          }
        ]
      },
      {
        id: 3,
        title: '验厂操作流程',
        list: [
          {
            id: 1,
            title: '设置基本清单',
            path: '/factory/inspection/basic',
            icon: 'list-alt',
            color: '#4580F3',
            isCompleted: false
          },
          {
            id: 2,
            title: '设置验厂清单',
            path: '/factory/inspection/item',
            icon: 'clipboard',
            color: '#31B965',
            isCompleted: false
          },
          {
            id: 3,
            title: '设置流程配置',
            path: '/factory/inspection/process',
            icon: 'sitemap',
            color: '#FE9A30',
            isCompleted: false
          },
          {
            id: 4,
            title: '创建验厂任务',
            path: 'mini',
            icon: 'calendar-check-o',
            color: '#F56C6C',
            isCompleted: true
          },
          {
            id: 5,
            title: '下载验厂报告',
            path: '/factory/order/list',
            icon: 'download',
            color: '#A259FF',
            isCompleted: false
          }
        ]
      }
    ] //流程列表
  },
  actions: {
    /**
     * 设置是否完成
     */
    async setCompleted({ rootState, state, dispatch }, targetPath) {
      if (!rootState.user.token) return
      try {
        const path = targetPath || rootState.route.nextRoute
        let processInfo = null
        for (const item of state.processList) {
          processInfo = item.list.find(item => item.path === path)
          if (processInfo) break
        }
        if (processInfo && !processInfo.isCompleted) {
          await addUseProcess({
            name: processInfo.title,
            url: processInfo.path,
            isCompleted: 1
          }).catch(() => {})
          await dispatch('loadCompleted')
        }
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * 加载是否全部完成
     */
    async loadCompleted({ rootState, state }) {
      if (!rootState.user.token) return
      try {
        const fetchData = async () => {
          const res = await getUseProcessList({ model: {}, page: 1, size: 9999 })
          const list = res.records || []
          state.processList = state.processList.map(process => {
            process.list = process.list.map(item => {
              item.isCompleted =
                item.path === '/login' ||
                item.path === 'mini' ||
                list.findIndex(childItem => childItem.url === item.path) !== -1
              return item
            })
            return process
          })
          state.isCompleted = state.processList.every(process => {
            return process.list.every(item => item.isCompleted === true)
          })
        }
        const debouncedFetch = useEventUtil.debounce(fetchData, 300)
        await debouncedFetch()
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * 设置是否提醒
     */
    async setRemind({ state }) {
      try {
        await setShowProofingProcess('true')
        state.isRemind = false
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * 加载是否提醒
     */
    async loadRemind({ state }) {
      try {
        const res = await isShowProofingProcess()
        state.isRemind = !res
      } catch (error) {
        state.isRemind = false
      }
    }
  }
}
